import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal';
import { getRenderable } from '../../lib/index';
import ContentWrapper from '../../ContentWrapper';
import Close from '../shared/components/Close';
import Body from './Body';

import classes from './index.module.scss';

class FitContent extends Modal {

    constructor(props) {
        super(props);

        this.onClose = this.onClose.bind(this);
    }

    onClose() {
        this.close();
        this.props.onClose();
    }

    __view(props) {
        const {
            children
        } = this.props;

        return (
            <ContentWrapper {...props} className={classes.modalContentFitContent}>
                <Close onClick={this.onClose} className={classes.modalContentClose}/>
                {children && <Body>{getRenderable(children, props)}</Body>}
            </ContentWrapper>
        );
    }
}

FitContent.propTypes = {
    children: PropTypes.any,
    onClose: PropTypes.func
};

FitContent.defaultProps = {
    onClose: () => null
};

export default FitContent;
